export const MESSAGE_LIST_CONTAINER = 'message-list';

/** Width from which a message row fits on a single line. */
export const MESSAGE_LIST_WIDE_MIN_WIDTH = 720;

export const MESSAGE_LIST_WIDE_QUERY = `@container ${MESSAGE_LIST_CONTAINER} (min-width: ${MESSAGE_LIST_WIDE_MIN_WIDTH}px)`;
